globalThis.backoffice = globalThis.backoffice || {};

backoffice.Contacts = (function()
{
  function Contacts($container) {
    this.events();
  }

  Contacts.prototype = {
    events: function() {
      var $communicationChannelPreferencesPanel = $('.communication-channel-preferences-panel');
      var $allCommunicationsSwitchery           = $communicationChannelPreferencesPanel.find('.all-communications-switchery');
      var $communicationChannelPreferencesList  = $communicationChannelPreferencesPanel.find('.communication-channel-preferences-list');
      var $form                                 = $communicationChannelPreferencesPanel.closest('form');
      var $allCommunicationsChannelStatusInput  = $form.find('.all-communications-channel-status-input');

      $allCommunicationsSwitchery.on('change', 'input[type=checkbox]', function(e) {
          e.preventDefault();
          var $checkbox = $(this);

          if($checkbox.is(':checked')) {
              $communicationChannelPreferencesList.show();
              $allCommunicationsChannelStatusInput.val("realtime");
          } else {
              $communicationChannelPreferencesList.hide();
              $allCommunicationsChannelStatusInput.val("disabled");
          }
      });
    }
  }

  return Contacts;
})();
